package one.healthium.meal_plans.tutorial.navigation

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner

class DefaultPersonalMealPlanTutorialComponent(
    componentContext: ComponentContext,
    private val onMealPlanClicked: (String) -> Unit,
    private val onCloseClicked: () -> Unit,
) : PersonalMealPlanTutorialComponent, ComponentContext by componentContext,
    ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onMealPlanClicked(id: String) {
        onMealPlanClicked.invoke(id)
    }

    override fun onCloseClicked() {
        onCloseClicked.invoke()
    }
}